import React from 'react';
import * as S from './styles';
import { MyDepartments } from './MyDepartments';
import { WhasappUsers } from './WhasappUsers';

const Departments = () => {

	
	return (
		<S.DepartmentsContainer>
			<S.HeaderContainer>
				<S.Title>Departamentos</S.Title>
				<S.Subtitle>Configure seu departamento com colaboradores</S.Subtitle>
			</S.HeaderContainer>
			<S.DepartmentsContent>
				<MyDepartments />
				<WhasappUsers />
			</S.DepartmentsContent>
		</S.DepartmentsContainer>
	);
};

export { Departments };